export const BC_TRT_DEFAULT_VALUE = ({ user, customer, fax = '1-855-952-2436' }) => ({
  sex: {
    male: true,
    female: false
  },
  billing: {
    MSP: true
  },
  pregnant: {
    yes: false,
    no: true
  },
  phoneFax: {
    phone: false,
    fax: true,
    value: fax
  },
  diagnosis: 'Low Testosterone',
  standingOrderRequests:
    'Testosterone (Free, Total), Estradiol, Prolactin, LH, FSH, Lipase, CRP, Total Insulin',
  HEMATOLOGY: {
    hematologyProfile: true,
    ferritin: true
  },
  CHEMISTRY: {
    glucoseFasting: true,
    hemoglobin: true,
    LIPIDS: {
      fullLipidProfile: true
    },
    THYROID_FUNCTION: {
      TSH: true
    },
    OTHER_CHEMISTRY_TESTS: {
      sodium: true,
      eGFR: true,
      potassium: true,
      albumin: true,
      alkPhos: true,
      ALT: true,
      B12: true,
      PSA2: true
    }
  }
});

export const BC_WL_DEFAULT_VALUE = ({ user, customer, fax = '1-855-952-2436' }) => ({
  billing: {
    MSP: true
  },
  pregnant: {
    yes: false,
    no: true
  },
  phoneFax: {
    phone: false,
    fax: true,
    value: fax
  },
  standingOrderRequests: 'Lipase, CRP, Total Insulin',
  HEMATOLOGY: {
    hematologyProfile: true
  },
  CHEMISTRY: {
    glucoseFasting: true,
    hemoglobin: true,
    LIPIDS: {
      fullLipidProfile: true
    },
    THYROID_FUNCTION: {
      TSH: true
    },
    OTHER_CHEMISTRY_TESTS: {
      sodium: true,
      eGFR: true,
      potassium: true,
      albumin: true,
      alkPhos: true,
      ALT: true,
      B12: true
    }
  }
});

const BC_LGV_BILLING = {
  MSP: true,
  patient: true
};

export const BC_LGV_DEFAULT_VALUE = ({ user, customer, organization }) => {
  const jackLgvExtraStandingOrders =
    'Uric Acid, Magnesium (Serum), Lipoprotein(a), AST, Cortisol (random), Serum iron (Fe), TIBC, % transferrin saturation, Free T3/Free T4, Serum Phosphate (PO4), Nucleated RBC (NRBC)';
  const jillLgvExtraStandingOrders =
    'Progesterone, Estradiol, LH, FSH, Testosterone (Total), Prolactin, DHEA-S, Serum iron (Fe), TIBC, % transferrin saturation, Free T3/Free T4, Uric Acid, Magnesium (Serum), AST, Lipoprotein(a), Cortisol (random), Serum Phosphate (PO4), Nucleated RBC (NRBC)';
  const defaultsByProfile = {
    jack_health: {
      ...BC_TRT_DEFAULT_VALUE({ user, customer }),
      billing: BC_LGV_BILLING,
      diagnosis: 'Preventative Evaluation',
      standingOrderRequests: `${
        BC_TRT_DEFAULT_VALUE({ user, customer }).standingOrderRequests
      }, ${jackLgvExtraStandingOrders}`,
      CHEMISTRY: {
        ...BC_TRT_DEFAULT_VALUE({ user, customer }).CHEMISTRY,
        LIPIDS: {
          ...BC_TRT_DEFAULT_VALUE({ user, customer }).CHEMISTRY.LIPIDS
        },
        THYROID_FUNCTION: {
          ...BC_TRT_DEFAULT_VALUE({ user, customer }).CHEMISTRY.THYROID_FUNCTION
        },
        OTHER_CHEMISTRY_TESTS: {
          ...BC_TRT_DEFAULT_VALUE({ user, customer }).CHEMISTRY
            .OTHER_CHEMISTRY_TESTS,
          PSA2: false,
          calcium: true,
          GGT: true
        }
      }
    },
    jill_health: {
      ...BC_WL_DEFAULT_VALUE({ user, customer }),
      sex: { male: false, female: true },
      billing: BC_LGV_BILLING,
      diagnosis: 'Preventative Evaluation',
      standingOrderRequests: `${
        BC_WL_DEFAULT_VALUE({ user, customer }).standingOrderRequests
      }, ${jillLgvExtraStandingOrders}`,
      HEMATOLOGY: {
        ...BC_WL_DEFAULT_VALUE({ user, customer }).HEMATOLOGY,
        ferritin: true
      },
      CHEMISTRY: {
        ...BC_WL_DEFAULT_VALUE({ user, customer }).CHEMISTRY,
        LIPIDS: {
          ...BC_WL_DEFAULT_VALUE({ user, customer }).CHEMISTRY.LIPIDS,
          apoB: true
        },
        THYROID_FUNCTION: {
          ...BC_WL_DEFAULT_VALUE({ user, customer }).CHEMISTRY.THYROID_FUNCTION
        },
        OTHER_CHEMISTRY_TESTS: {
          ...BC_WL_DEFAULT_VALUE({ user, customer }).CHEMISTRY.OTHER_CHEMISTRY_TESTS,
          calcium: true,
          GGT: true
        }
      }
    }
  };
  const normalizedGender = customer?.gender?.toLowerCase?.();
  if (normalizedGender === 'male' || normalizedGender === 'm') {
    return defaultsByProfile.jack_health;
  }
  if (normalizedGender === 'female' || normalizedGender === 'f') {
    return defaultsByProfile.jill_health;
  }
  return defaultsByProfile[organization] || defaultsByProfile.jack_health;
};

const BC_LGV_PAID_EXTRA_JACK = {
  LIFELABS: {
    danTalya: true,
    psaTotal: true,
    shbg: true,
    vitaminD25: true,
    fastingNo: false,
    fastingYes: true,
    fastingHours: '8-10',
    diagnosisComments: '',
  }
};

const BC_LGV_PAID_EXTRA_JILL = {
  LIFELABS: {
    danTalya: true,
    psaTotal: false,
    shbg: false,
    vitaminD25: true,
    fastingNo: false,
    fastingYes: true,
    fastingHours: '8-10',
    diagnosisComments: '',
  }
};

export const BC_LGV_PAID_DEFAULT_VALUE = ({ user, customer, organization }) => {
  const isMale = ['male', 'm'].includes(customer?.gender?.toLowerCase?.());
  return {
    ...BC_LGV_DEFAULT_VALUE({ user, customer, organization }),
    diagnosis: '',
    ...(isMale ? BC_LGV_PAID_EXTRA_JACK : BC_LGV_PAID_EXTRA_JILL),
  };
};
